<template>
  <PageGrid>
    <template #left>
      <BackButton :go-back="goBack" />
    </template>
    <template #right>
      <div class="flex flex-col gap-10">
        <div class="flex flex-col gap-2.5">
          <h2 class="text-3xl/[34px]">{{ data.name }}</h2>
          <p class="text-sm/[22px]">
            {{ dayjs(data.date).format("MMM DD.YYYY") }}
          </p>
        </div>

        <Wysiwyg :content="data?.description" />
      </div>
    </template>
  </PageGrid>
</template>

<script setup>
  import dayjs from "dayjs";

  const router = useRouter();
  const data = ref([]);
  const route = useRoute();
  const slug = computed(() => route.params.slug);

  const { globalPageTitle } = useGlobalState();

  const { data: queryData, pending: loading } = await usePersistedFetch("publicationBySlug", { slug: slug.value });

  onMounted(() => {
    globalPageTitle.value = "News";
  });

  watchEffect(() => {
    if (
      !loading?.value &&
      queryData?.value &&
      queryData?.value?.publicationBySlug === null
    ) {
      throw createError({
        statusCode: 404,
        statusMessage: "News not found",
      });
    } else {
      data.value = queryData.value?.publicationBySlug || [];
    }
  });

  const goBack = () => {
    router.push(`/news`);
  };
</script>